module.exports = __webpack_public_path__ + "static/img/12bac.850ed93.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/12bac.jpg
// module id = H5Yo
// module chunks = 1